<template>
    <div class='body-box marginBox'>
        <!-- 搜索与添加区域 -->
        <el-row class="plan selectBox" :gutter="16">
            <el-col :span='4'>
                <search-input v-model="search.userName" placeholder="请输入使用人搜索" @change="handleQuery" />
            </el-col>

            <el-col :span='4'>
                <search-input v-model="search.couponNameUseId" placeholder="请输入优惠券名称/使用ID搜索" @change="handleQuery" />
            </el-col>

            <el-col :span='4'>
                <search-input v-model="search.couponPrice" type="number" placeholder="请输入优惠券面额搜索" @change="handleQuery" />
            </el-col>

            <el-col :span='4'>
                <el-date-picker
                        v-model="search.eliminateTime"
                        placeholder="消券截止日期"
                        type="datetime"
                        value-format="timestamp"
                        @change="handleQuery"
                ></el-date-picker>
            </el-col>
        </el-row>

        <el-table :height="'calc(100% - 75px)'" :data='eliminateCouponList' class='button-box' render ref="eliminateCouponList">
          <el-table-column label='使用人' prop='userName'>
            <template slot-scope="scope">
              {{scope.row.userName}}
              <span v-if='scope.row.userBrief'>({{scope.row.userBrief}})</span>
            </template>
          </el-table-column>
            <el-table-column label='优惠券使用ID' prop='couponId' />
            <el-table-column label='优惠券名称' prop='couponName' />
            <el-table-column label='适用产品' prop='applicableProduct'>
                <template slot-scope="scope">
                    {{statusChange(scope.row.applicableProduct)}}
                </template>
            </el-table-column>
            <el-table-column label='优惠券面额' prop='couponPrice'/>
            <el-table-column label='使用记录' prop='useRecord' />
            <el-table-column label='消券时间' prop='eliminateTime'>
                <template slot-scope="scope">
                    {{scope.row.eliminateTime | formatDate('yyyy-MM-dd hh:mm:ss')}}
                </template>
            </el-table-column>
            <el-table-column label='消券备注' prop='eliminateRemark'>
                <template slot-scope="scope">
                    {{scope.row.eliminateRemark}}
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页区域 -->
        <div class="fixedBox"><pagination ref='page' :query-param.sync='queryInfo' @pagination='getEliminateCouponList' /></div>
    </div>
</template>

<script>

  import SearchInput from '@/components/common/searchInput/searchInput'
  import Pagination from '@/components/common/Pagination/index'
  import { getEliminateCouponList } from '@/api/coupon/coupon'
  import { enumStatus, enumTypes } from '@/js/enum'
  import { formatDate } from '@/js/momen'

  export default {
    name: 'userCoupon',
    components: { SearchInput, Pagination },
    data() {
      return {
        // 查询参数
        queryInfo: {
          current: 1,
          size: 10,
          price: '',
          type: ''
        },
        eliminateCouponList: [],
        search: {},
        couponList: [],
        enumTypes
      }
    },
    created() {
      this.handleQuery()
    },
    mounted() {
    },
    methods: {
      // 状态码转换
      statusChange(p){
        let text = ''
        enumStatus.forEach(res => {
          if (p === res.key) {
            text = res.value
          }
        })
        return text
      },
      handleQuery() {
        this.$nextTick(() => {
          this.$refs.page.run()
        })
      },
      // 查看优惠券
      getEliminateCouponList(data,cb) {
        getEliminateCouponList(data, this.search).then(res => {
          this.eliminateCouponList = cb(res)
        })
      },
    }
  }
</script>

<style lang="less" scoped>

</style>